import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'

import { FETCH_STATUS } from '../constants'

export const NAME = 'palmetto'

const DEFAULT_LAT_LNG = {
  X: -78.853771,
  Y: 33.648993,
}

const fetchStatus = (state = FETCH_STATUS.NOT_YET_FETCHED, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return FETCH_STATUS.FETCHING
    case ActionTypes.FETCH_FAILURE:
      return FETCH_STATUS.FETCH_FAILED
    case ActionTypes.FETCH_SUCCESS:
      return FETCH_STATUS.LOADED
    default:
      return state
  }
}

const getIncidentId = (incident) => incident.incidentNumber

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      let byId = {}
      action.incidents.forEach((incident) => {
        const i = {
          ...incident,
          longitude:
            (incident.longitude !== 'NaN' && incident.longitude) ||
            DEFAULT_LAT_LNG.X,
          latitude:
            (incident.latitude !== 'NaN' && incident.latitude) ||
            DEFAULT_LAT_LNG.Y,
        }
        byId[getIncidentId(incident)] = i
      })
      return byId
    case ActionTypes.SEND_TO_PALMETTO:
      state[action.incidentNumber].sentToPalmetto = true
      return state
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      return action.incidents.map(getIncidentId)
    default:
      return state
  }
}

const initialSelected = { incidentIds: [], current: 0 }
const selected = (state = initialSelected, action) => {
  const { incidentIds, current } = state
  switch (action.type) {
    case ActionTypes.SELECT_INCIDENTS:
      return {
        incidentIds: action.incidentIds,
        current: 0,
      }
    case ActionTypes.NEXT_INCIDENT:
      return {
        ...state,
        current: current + (current < incidentIds.length - 1 ? 1 : 0),
      }
    case ActionTypes.PREV_INCIDENT:
      return {
        ...state,
        current: current - (current > 0 ? 1 : 0),
      }
    case ActionTypes.CLEAR_SELECTION:
      return initialSelected
    default:
      return state
  }
}

const palmettoIncidents = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_PALMETTO_INCIDENTS_SUCCESS:
      return action.incidents
    default:
      return state
  }
}

const eventTypes = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_EVENT_TYPES_SUCCESS:
      return action.types
    default:
      return state
  }
}

const initialFormState = {
  open: false,
  eventType: '',
  incident: '',
  title: '',
}

const formState = (state = initialFormState, action) => {
  switch (action.type) {
    case ActionTypes.OPEN_FORM:
      return { ...initialFormState, open: true }
    case ActionTypes.SELECT_INCIDENTS:
    case ActionTypes.CLEAR_SELECTION:
    case ActionTypes.CLOSE_FORM:
    case ActionTypes.SEND_TO_PALMETTO:
      return initialFormState
    case ActionTypes.SET_EVENT_TYPE:
      return { ...state, eventType: action.eventType }
    case ActionTypes.SET_INCIDENT:
      return { ...state, incident: action.incident }
    case ActionTypes.SET_TITLE:
      return { ...state, title: action.title }
    default:
      return state
  }
}

const reducer = combineReducers({
  byId,
  allKeys,
  selected,
  fetchStatus,
  palmettoIncidents,
  eventTypes,
  formState,
})

export default reducer
